import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as createListReduceObject } from '../../../../../common/reducers/list/reducer';

import specialPagesListSaga from './sagas/specialPagesListSaga';

export default [
  // Lists
  ...createCombineMapItem('specialPagesList', createListReduceObject, [
    specialPagesListSaga
  ])
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/specialPages/reducers/static/lists/reducersMap.js